import {
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Space,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import { QuarantineApi } from '@Apis';
import axios from 'axios';
import { usePermissionStore } from '../../../models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
import { QuarantineLogTypeEnum } from '../../../types/log';

export const AutoDeleteDaysSetting = React.memo(
  ({ quarantineType }: { quarantineType: QuarantineLogTypeEnum }) => {
    const { widthEditablePermission } = usePermissionStore();
    const qtEditPermission = widthEditablePermission(
      PermissionNameEnum.quarantine
    );
    const [days, setDays] = useState(0);

    useEffect(() => {
      const abortController = new AbortController();
      const fetchData = async () => {
        try {
          const res = await QuarantineApi.apiGetAutoDeleteDaysSetting({
            signal: abortController.signal,
          });
          setDays(res.data.expiredDay);
        } catch (e: any) {
          if (axios.isCancel(e)) {
            console.log('Request cancelled:', e.message);
          }
        }
      };
      fetchData();
      return () => {
        abortController.abort('AutoDeleteDaysSetting unmount, cancel request');
        setDays(0);
      };
    }, []);

    const onClick = async (value: number) => {
      await QuarantineApi.apiUpdateAutoDeleteDaysSetting(value);
      const res = await QuarantineApi.apiGetAutoDeleteDaysSetting();
      setDays(res.data.expiredDay);
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const AutoDeleteMenu = (props: any) => {
      // inline service fixed 30 days auto delete
      if (
        [
          QuarantineLogTypeEnum.GmailInline,
          QuarantineLogTypeEnum.ExchangeInline,
        ].includes(quarantineType)
      ) {
        return <Space>&nbsp;30&nbsp;</Space>;
      }
      return (
        <Menu px="8px">
          <MenuButton
            variant="secondary"
            width="60px"
            disabled={!qtEditPermission}
          >
            {days || ''}
          </MenuButton>
          <MenuList width="60px">
            {[30, 60, 90].map((value) => (
              <MenuItem
                key={value}
                onClick={async () => {
                  await onClick(value);
                }}
              >
                {value}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      );
    };

    return (
      <Flex align="center">
        <Trans i18nKey="quarantine.tips.autoDelete">
          placeholder
          <AutoDeleteMenu>placeholder</AutoDeleteMenu>
          placeholder
        </Trans>
      </Flex>
    );
  }
);
